const indexWords = [
    "KMP",
    "Visualization",
    "Finite State Automata",
    "Finite State Automaton",
    "FSA",
    "DFA",
];

export default indexWords;